import React from 'react';
import { styled } from 'linaria/react';
import { breakpoints } from '../../../../../media';

type CardWrapperProps = {
	className: string;
	ref?: (node?: Element | null) => void;
	onClick?: (event: React.MouseEvent<HTMLElement>) => void;
	href: string;
	wide: boolean;
};

export const CardWrapper = styled.a<CardWrapperProps>`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	width: 100%;
	padding: 16px;
	text-decoration: none;
	color: var(--text-primary);
	border: 1px solid var(--control-minor);
	border-radius: 8px;

	${breakpoints.only.tablet} {
		grid-column: ${({ wide }) => (wide ? 'span 3' : 'span 2')};
	}

	${breakpoints.only.mobile} {
		flex-direction: row;
		padding: 12px;
		column-gap: 8px;
		row-gap: 0;
	}
`;

export const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	width: 100%;
	height: 100%;
`;
